export function BorderButton({
  onClick,
  children,
  type = 'button',
  disabled,
}: {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactNode
  type?: 'button' | 'submit'
  disabled?: boolean
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        w-full p-[1.5px]
        rounded-[calc(1rem-3px)]
        transition-all duration-200
        hover:shadow-[0_0_20px_rgba(35,235,173,0.15)]
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
    >
      <div
        className="
          w-full
          rounded-[calc(1rem-3px)]
          bg-brand-grey
          flex items-center justify-center gap-2
          py-[11px]
          text-sm font-bold text-black
          transition-colors duration-150
        "
      >
        {children}
      </div>
    </button>
  )
}

export function AnimatedBorderButton({
  onClick,
  children,
}: {
  onClick?: (e: React.MouseEvent) => void
  children: React.ReactNode
}) {
  return (
    <>
      <style>{`
        @keyframes gradient-spin {
          0% {
            background-position: 0% center;
          }
          100% {
            background-position: 200% center;
          }
        }
      `}</style>

      <div
        onClick={onClick}
        className="relative w-full cursor-pointer overflow-hidden rounded-full p-[3px] group"
      >
        <div
          className="
            absolute inset-0 global-border-radius z-0
            bg-gradient-to-r from-[#008080] via-[#9845FF] via-[#008080]  to-[#9845FF]
            bg-[length:200%_100%]
            animate-[gradient-spin_1s_linear_infinite]
            group-hover:brightness-110
          "
        />
        <div
          className="
            relative z-10 w-full
            rounded-full
            bg-brand-grey hover:bg-[#22252A] text-black hover:text-white
            flex items-center justify-center gap-2
            py-[11px]
            text-sm font-bold text-[#F5F5F5]
            transition-colors duration-300
            group-hover:bg-[#22252A]
          "
        >
          {children}
        </div>
      </div>
    </>
  )
}

export function AnimatedSubmitButton({
  onClick,
  disabled,
  children,
  type = 'button',
  title,
}: {
  onClick?: () => void
  disabled?: boolean
  children: React.ReactNode
  type?: 'button' | 'submit'
  title?: string
}) {
  return (
    <>
      <style>{`
        @keyframes gradient-spin {
          0% {
            background-position: 0% center;
          }
          100% {
            background-position: 200% center;
          }
        }
      `}</style>

      <button
        type={type}
        disabled={disabled}
        onClick={onClick}
        className={`
          relative w-full overflow-hidden
          rounded-full p-[3px] group
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        <div
          className="
            absolute inset-0 rounded-full z-0
            bg-gradient-to-r from-[#008080] via-[#9845FF] via-[#008080] to-[#9845FF]
            bg-[length:200%_100%]
            animate-[gradient-spin_1s_linear_infinite]
            group-hover:brightness-110
            
          "
        />
        <div
          className="
            relative z-10 w-full
            rounded-full
            bg-brand-grey text-black
            flex items-center justify-center gap-2
            py-[13px]
            text-sm font-bold text-[#F5F5F5]
            transition-colors duration-300
          "
        >
          {children}
        </div>
      </button>
    </>
  )
}


export function StaticBorderButton({
  onClick,
  children,
  type = 'button',
  disabled,
}: {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactNode
  type?: 'button' | 'submit'
  disabled?: boolean
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        relative w-full overflow-hidden rounded-full p-[3px] transition-all duration-200
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
    >
      <div
        className="absolute inset-0 rounded-full z-0 opacity-40"
      />
      <div
        className="
          relative z-10 w-full
          rounded-full
          bg-brand-grey
          flex items-center justify-center gap-2
          py-2
          3xl:text-xl
          text-base font-semibold
          text-brand-card
          border border-brand-bg
          transition-all duration-200
          hover:bg-brand-grey/70
        "
      >
        {children}
      </div>
    </button>
  )
}